import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import heroImage from "../../assets/hero-health.png";
import bed2 from "../../assets/bed2.jpeg";

const images = [heroImage, bed2];

const HeroSection = () => {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 6000);

        return () => clearInterval(interval);
    }, []);

    return (
        <section className="relative min-h-[85vh] flex items-center overflow-hidden bg-white">

            {/* Background Images */}
            <div className="absolute inset-0 overflow-hidden">
                {images.map((image, index) => (
                    <motion.div
                        key={index}
                        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                        style={{
                            backgroundImage: `url(${image})`,
                            zIndex: currentImage === index ? 2 : 1,
                        }}
                        animate={{
                            opacity: currentImage === index ? 1 : 0,
                            scale: currentImage === index ? 1 : 1.15,
                        }}
                        transition={{
                            opacity: {
                                duration: 1.5,
                                ease: "easeInOut",
                            },
                            scale: {
                                duration: 6,
                                ease: "linear",
                            },
                        }}
                    />
                ))}
            </div>

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-white/40 z-10" />

            {/* Green Glow */}
            <div className="absolute -left-32 top-1/2 -translate-y-1/2 w-[850px] h-[750px] rounded-full bg-green-900/90 blur-[180px] z-20 pointer-events-none" />

            {/* Content */}
            <div className="relative z-30 w-full pl-6 lg:pl-16 xl:pl-24 py-20">
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    className="max-w-2xl"
                >
                    <p className="inline-flex px-5 py-2 text-center border border-white rounded-full text-white text-sm sm:text-base mb-7">
                        Welcome to AfyaEquip
                    </p>

                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white">
                        Quality Health care Equipments
                    </h1>

                    <p className="mt-6 text-lg text-white max-w-xl">
                        Providing trusted healthcare equipment that improves comfort,
                        independence, and quality of life.
                    </p>

                    <div className="mt-8 flex flex-wrap gap-4">
                        <Link
                            to="/shop"
                            className="group flex items-center gap-3 bg-white text-black px-7 py-3 rounded-full font-medium transition duration-300 shadow-lg hover:bg-transparent hover:text-white border border-white"
                        >
                            <span>
                                Shop Equipment
                            </span>

                            <span
                                className="flex items-center justify-center w-8 h-8 rounded-full bg-green-600 text-white transition duration-300 group-hover:bg-white group-hover:text-green-600"
                            >
                                <ArrowRight size={18} />
                            </span>
                        </Link>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;